{
  "title": "Longstrider",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a pinch of dirt)",
  "duration": "1 hour",
  "description": [
    "You touch a creature. The target’s speed increases by 10 feet until the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, you can target one additional creature for each slot level above 1st."
  ],
  "spellLists": ["artificer", "bard", "druid", "ranger", "wizard"]
}
